import { defineMessages } from 'utils/intl';

export default defineMessages({
  header: 'Sklep {shop} – Urządzenia Firewall oraz Sieciowe',
  description: `Doradzamy w zakresie zakupu sprzętu IT. Jesteśmy autoryzowanym partnerem różnych producentów rozwiązań sieciowych,
    a najwyższa jakość świadczonej przez nas obsługi była już wielokrotnie potwierdzana przez producentów dostarczanych przez
    nas rozwiązań w formie nagród i wyróżnień a przede wszystkim przez naszych klientów.`,
});
